import(/* webpackMode: "eager", webpackExports: ["OiiTable"] */ "/app/src/app/(training)/tasks/years/oii/table.tsx");
